module.exports = __webpack_public_path__ + "static/media/FooterRedBorder.1e199096.svg";